export default __webpack_public_path__ + "static/media/property_780.b7e8fd1a.png";